import React, {PropTypes, Component} from 'react';
import utils from '../../utils/utils';
import Masonry from 'react-masonry-component';
import DatePickerComponent from '../../containers/DatePicker/DatePicker';
import Pager from '../partial/Pager/Pager';
import NoResultHeader from '../partial/NoResultHeader/NoResultHeader';
import PageTitle from '../partial/PageTitle/PageTitle';
import Breadcrumbs from '../partial/Breadcrumbs/Breadcrumbs';
import SingleArticle from '../partial/SingleArticle/SingleArticle';
const s = require('./posts.scss');


class PostsList extends Component {
  modifyClass(index) {
    const noMediaClass = index % 6 === 1 ? s.noMedia1 : s.noMedia2;
    return index % 3 === 1 ? `${noMediaClass}  ${s.gridItem}` : `${s.noMedia3} ${s.gridItem}`;
  }

  addDatePicker() {
    const component = [];
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined' && navigator.userAgent.indexOf('MSIE') === -1) {

      component.push(<DatePickerComponent data-hook="posts-list-datepicker" key="1"/>);
    } else {
      component.push(<span key="1"/>);
    }
    return component;
  }

  render() {
    const {loading, numPages, page, tag, title, content, pageHeader, seo, search, isDatePickerEnabled, locale} = this.props;

    if (content.length === 0) {
      return (
        <div className={s.postsWrapper} >
          {utils.getHelemt(seo)}
          <div className={s.container}>
            <NoResultHeader search={() => search('')} locale={locale}/>
          </div>
        </div>
      );
    } else {
      return (
        <div className={s.postsWrapper} data-hide={loading}>
          {utils.getHelemt(seo)}
          <div className={s.container}>
            {isDatePickerEnabled && <div className={s.datePickerComponent} id="datePickerWrapper">{this.addDatePicker()}</div>}
            <PageTitle title={pageHeader.title} description={pageHeader.description}/>
            <Breadcrumbs title={title} showing={locale[`wix-general_page_showing`]}/>
            <div className={s.myGalleryClass}>
              <Masonry
                elementType={'ul'}
                className={s.postsGallery}
                disableImagesLoaded={false}
                updateOnEachImageLoad={false}
                >
                {
                  content.map(article => <SingleArticle key={article.index} date={utils.generatePostDate(article.date)} title={article.title} content={utils.getContent(article.content)} links={article.links} itemDeepLink={`/article/${article.id}`} customClass={article.withoutMedia ? this.modifyClass(article.index) : ''}/>)
                }
              </Masonry>
            </div>
          </div>
          <Pager data-hook="posts-list-pager" numPages={numPages} visiblePages="3" current={page} relPath={tag}/>
        </div>
      );
    }
  }
}

PostsList.propTypes = {
  loading: PropTypes.bool.isRequired,
  numPages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  tag: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.array.isRequired,
  pageHeader: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  seo: PropTypes.object.isRequired,
  search: PropTypes.func.isRequired,
  isDatePickerEnabled: PropTypes.bool
};

export default PostsList;



// WEBPACK FOOTER //
// ./components/PostsList/PostsList.js